import { render, staticRenderFns } from "./CwInfo.vue?vue&type=template&id=8c71c502&scoped=true&"
import script from "./CwInfo.vue?vue&type=script&lang=js&"
export * from "./CwInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c71c502",
  null
  
)

export default component.exports